import axiosHelper from '@/helpers/axiosHelper';

export default axiosHelper.mergeAxiosRequestTransformerWithDefaults(
  (data: any, headers: any): any => {
    Object.assign(
      headers.common,
      {
        'APP-AUTH-AUTH-TOKEN': window.localStorage.getItem('accessToken'),
        'APP-AUTH-PLACE-ID': window.localStorage.getItem('placeId'),
      }
    );

    return data;
  }
);
